import React, { forwardRef } from 'react';

const TagWrapper = forwardRef(({ tag: Tag = 'div', children, ...props }, ref) => {
  return (
    <Tag ref={ref} {...props}>
      {children}
    </Tag>
  );
});

export default TagWrapper;
